import EmailIcon from '@mui/icons-material/Email';
import PrintIcon from '@mui/icons-material/Print';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import { CircularProgress, Drawer, Stack, Typography } from '@mui/material';

import * as React from 'react';
import { LargeBtn } from '../../../components';
import { BillPrinter, PrintBtn } from '../../printer';
import { useAppSelector } from '../../../redux-store/hooks';


interface ShareBillDrawerProps {
    open: boolean;
    isLoading: boolean
    handleRemoveTab: () => void;
}

const BillProcessDrawer: React.FC<ShareBillDrawerProps> = ({ open, isLoading, handleRemoveTab }) => {

    const bill = useAppSelector(state => state.table.createdBill);

    if (!open) {
        return <></>
    }

    return (
        <Stack sx={{ height: "50vh" }} justifyContent={"space-between"}>
            <Stack flexDirection={"row"} justifyContent={"center"} alignItems={"center"} gap={2} p={2}>
                {/* <PrintBtn /> */}
                {bill && <BillPrinter bill={bill} iconStyles={{ fontSize: 60 }} btnStyles={{
                    minWidth: '200px', // Adjust the width as needed
                    height: '100px', // Adjust the height as needed
                    borderRadius: 2,
                    fontSize: '18px',
                    fontWeight: 'bold',
                    padding: '10px 20px',
                    flexDirection: "column"
                }} />}
                {/* <LargeBtn
                    variant="contained"
                    color="primary"
                    size="large"
                >
                    <PrintIcon sx={{ fontSize: 60 }} />
                    {bill && <BillPrinter bill={bill} btnStyles={{
                        minWidth: '200px', // Adjust the width as needed
                        height: '100px', // Adjust the height as needed
                        borderRadius: 2,
                        fontSize: '18px',
                        fontWeight: 'bold',
                        padding: '10px 20px',
                        flexDirection: "column"
                    }} />}
                    <Typography variant="h6">Print</Typography>
                </LargeBtn> */}

                <LargeBtn
                    variant="contained"
                    color="secondary"
                    size="large"
                    disabled
                >
                    <EmailIcon sx={{ fontSize: 60 }} />
                    <Typography variant="h6">Email</Typography>
                </LargeBtn>

                <LargeBtn
                    variant="contained"
                    color="success"
                    size="large"
                    disabled
                >
                    <WhatsAppIcon sx={{ fontSize: 60 }} />
                    <Typography variant="h6">Whatsapp</Typography>
                </LargeBtn>

                <LargeBtn
                    variant="contained"
                    color="error"
                    size="large"
                    onClick={handleRemoveTab}
                >
                    <CancelPresentationIcon sx={{ fontSize: 60 }} />
                    <Typography variant="h6">Close Table</Typography>
                </LargeBtn>
            </Stack>

        </Stack>
    );
}

export { BillProcessDrawer };

